import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import './firebase/config'
import '@mdi/font/css/materialdesignicons.css'
import './assets/theme.css'
import './registerServiceWorker' // Import service worker registration

import auth from './store/modules/auth'
import search from './store/modules/search'
import theme from './store/modules/theme'
import preferences from './store/modules/preferences'
import pwa from './store/modules/pwa'

Vue.use(Vuex)

// Create store
const store = new Vuex.Store({
  modules: {
    auth,
    search,
    theme,
    preferences,
    pwa
  }
})

// Register beforeinstallprompt event
window.addEventListener('beforeinstallprompt', (e) => {
  // Prevent the mini-infobar from appearing on mobile
  e.preventDefault();
  // Store the event so it can be triggered later
  store.dispatch('pwa/saveInstallPrompt', e);
});

// Check if app is already installed
if (typeof window !== 'undefined') {
  store.dispatch('pwa/checkInstallation');
}

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
